<template>
  <div class="page">
    <div class="bg-content padding15">
      <div class="m-b-24">
        <el-button type="primary" size="small" @click="sessionTime(); timeVisable = true" plain>设置会话时长</el-button>
        <el-button type="primary" size="small" @click="portVisable = true" plain>设置端口</el-button>
        <el-button type="primary" size="small" @click="addConfShow" plain>添加服务</el-button>
        <el-button type="primary" size="small" @click="addOtherConfShow" plain>添加辅助配置</el-button>
      </div>
      <div class="padding15-tb">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="短信" name="msg">
            <div class="padding15-tb">
              <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
              <el-table size="small" :data="messageMsg.list" @row-click="rowClick" highlight-current-row>
                <el-table-column property="supplierName" fixed label="服务名称"/>
                <el-table-column property="supplier" label="简称"/>
                <el-table-column property="requestUrl" label="请求地址"/>
                <el-table-column property="asyReceiverUrl1" label="回推地址1"/>
                <el-table-column property="asyReceiverUrl2" label="回推地址2"/>
                <el-table-column property="confDesc" label="备注"/>
                <el-table-column property="weight" label="权重"/>
                <el-table-column property="delayTime" label="延迟时间(ms)"/>
                <el-table-column property="maxSerialNum" label="最大串行数"/>
                <el-table-column property="unitPrice" label="线路单价(元)"/>
                <el-table-column label="是否有资源">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
               </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                    <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                    <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                    <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="text center margin15-tb">
                <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageMsg.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="语音" name="ivr">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="messageIvr.list" @row-click="rowClick" highlight-current-row>
              <el-table-column property="supplierName" fixed label="服务名称"/>
              <el-table-column property="supplier" label="简称"/>
              <el-table-column property="requestUrl" label="请求地址"/>
              <el-table-column property="asyReceiverUrl1" label="回推地址1"/>
              <el-table-column property="asyReceiverUrl2" label="回推地址2"/>
              <el-table-column property="confDesc" label="备注"/>
              <el-table-column property="weight" label="权重"/>
              <el-table-column property="delayTime" label="延迟时间(ms)"/>
              <el-table-column property="maxSerialNum" label="最大串行数"/>
              <el-table-column property="unitPrice" label="线路单价(元)"/>
              <el-table-column label="是否有资源">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
               </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                  <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                  <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                  <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageIvr.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="智能语音" name="ivoice">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="messageIvoice.list" @row-click="rowClick" stripe highlight-current-row>
              <el-table-column property="supplierName" fixed label="服务名称"/>
              <el-table-column property="supplier" label="简称"/>
              <el-table-column property="requestUrl" label="请求地址"/>
              <el-table-column property="asyReceiverUrl1" label="回推地址1"/>
              <el-table-column property="asyReceiverUrl2" label="回推地址2"/>
              <el-table-column property="confDesc" label="备注"/>
              <el-table-column property="weight" label="权重"/>
              <el-table-column property="delayTime" label="延迟时间(ms)"/>
              <el-table-column property="maxSerialNum" label="最大串行数"/>
              <el-table-column property="unitPrice" label="线路单价(元)"/>
              <el-table-column label="是否有资源">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
              </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                  <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                  <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                  <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageIvoice.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="场景语音" name="svoice">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="messageSvoice.list" @row-click="rowClick" stripe highlight-current-row>
              <el-table-column property="supplierName" fixed label="服务名称"/>
              <el-table-column property="supplier" label="简称"/>
              <el-table-column property="requestUrl" label="请求地址"/>
              <el-table-column property="asyReceiverUrl1" label="回推地址1" min-width="60"/>
              <el-table-column property="asyReceiverUrl2" label="回推地址2" min-width="60"/>
              <el-table-column property="confDesc" label="备注" min-width="180"/>
              <el-table-column property="weight" label="权重"/>
              <el-table-column property="delayTime" label="延迟时间(ms)"/>
              <el-table-column property="maxSerialNum" label="最大串行数" min-width="60"/>
              <el-table-column property="unitPrice" label="线路单价(元)"/>
              <el-table-column label="是否支持重播" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.isRetry === false">否</div>
                  <div v-if="scope.row.isRetry === true">是</div>
                </template>
              </el-table-column>
              <el-table-column label="是否有资源" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.isResource === false">否</div>
                  <div v-if="scope.row.isResource === true">是</div>
                </template>
              </el-table-column>
              <el-table-column label="状态" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                  <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                  <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                  <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageSvoice.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="辅助配置" name="otherConf">
            <div class="padding15-tb">
              <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
              <el-table size="small" :data="messageOther.list" @row-click="rowClick" highlight-current-row>
                <el-table-column property="supplierName" fixed label="服务名称"/>
                <el-table-column property="supplier" label="简称"/>
                <el-table-column property="requestUrl" label="请求地址"/>
                <!--<el-table-column property="asyReceiverUrl1" label="回推地址1"/>-->
                <!--<el-table-column property="asyReceiverUrl2" label="回推地址2"/>-->
                <el-table-column property="confDesc" label="备注"/>
                <!--<el-table-column property="weight" label="权重"/>-->
                <!--<el-table-column property="delayTime" label="延迟时间(ms)"/>-->
                <!--<el-table-column property="maxSerialNum" label="最大串行数"/>-->
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                    <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                    <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                    <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="text center margin15-tb">
                <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageOther.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="闪信" name="fmsg">
            <div class="padding15-tb">
              <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="服务名称" label-width="80px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="80px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; serverList();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
              <el-table size="small" :data="messageFmsg.list" @row-click="rowClick" highlight-current-row>
                <el-table-column property="supplierName" fixed label="服务名称"/>
                <el-table-column property="supplier" label="简称"/>
                <el-table-column property="requestUrl" label="请求地址"/>
                <el-table-column property="asyReceiverUrl1" label="回推地址1"/>
                <el-table-column property="asyReceiverUrl2" label="回推地址2"/>
                <el-table-column property="confDesc" label="备注"/>
                <el-table-column property="weight" label="权重"/>
                <el-table-column property="delayTime" label="延迟时间(ms)"/>
                <el-table-column property="maxSerialNum" label="最大串行数"/>
                <el-table-column property="unitPrice" label="线路单价(元)"/>
                <el-table-column label="是否有资源">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
               </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                    <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                    <div v-if="scope.row.status === 2" style="color: #909399;">仅保持原有的通话</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editConfShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                    <el-button type="text" @click="deleteConf(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="text center margin15-tb">
                <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="messageFmsg.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="padding15-tb" v-if="portTableVisable">
        <el-tabs>
          <div class="padding15-tb">
            <el-table size="small" highlight-current-row :data="portPageRes.list" @sort-change="portSort">
              <el-table-column property="port" fixed label="端口" sortable="custom"/>
              <el-table-column property="portDescribe" label="描述"/>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status === 0" style="color: #F56C6C;">禁用</div>
                  <div v-if="scope.row.status === 1" style="color: #67C23A;">启用</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="updatePortShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编辑</el-button>&nbsp;&nbsp;
                  <el-button type="text" @click="deletePort(scope.row.id)" size="small"><i class="el-icon-delete"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                :total="portPageRes.totalRecords"
                :page-size="portSearchReq.limit"
                :current-page="portSearchReq.page"
                @current-change="currentChange"
                @size-change="sizeChange">
              </el-pagination>
            </div>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addPortShow" style="margin-left: 45%;">添加端口</el-button>
        </el-tabs>
      </div>
      <div class="dialog">
        <!--设置会话时长-->
        <el-dialog title="请输入会话时长（单位：秒）" :visible.sync="timeVisable" width="40%" center>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="small" label-width="140px">
                <el-form-item label="会话时长">
                  <el-input-number :min="0" v-model="time" style="margin-left: 10%; width: 65%;"/>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="timeVisable = false">取 消</el-button>
            <el-button type="primary" @click="updateSessionTime">确 定</el-button>
          </span>
        </el-dialog>
        <!--修改端口-->
        <el-dialog title="修改端口" :visible.sync="portVisable" width="50%" center>
          <el-form>
            <el-form-item label="">
              <el-select v-model="modifyPort.supplierId" placeholder="请选择" style="width: 25%;" @change="ports">
                <el-option v-for="item in this.allServers()" :key="item.id" :label="item.supplierName" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-form>
          <div>
            <el-transfer :data="portRes" v-model="modifyPort.portIds" :titles="['启用','禁用']" :props="{key:'id',label:'port'}"
                         :filterable="true"/>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="modifyPortStatus">提 交</el-button>
          </span>
        </el-dialog>
        <!--添加修改服务-->
        <el-dialog :title="isAdd?'添加服务':'修改服务'" :visible.sync="serverVisable" width="70%" center>
          <el-form size="small" label-width="130px" class="margin15-tb">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="服务名称：">
                  <el-input v-model="serverInfo.supplierName"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="简称：">
                  <el-input v-model="serverInfo.supplier"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="账号：">
                  <el-input v-model="serverInfo.userName"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码：">
                  <el-input type="password" v-model="serverInfo.password"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="请求地址：">
                  <el-input v-model="serverInfo.requestUrl"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回推地址1：">
                  <el-input v-model="serverInfo.asyReceiverUrl1"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="回推地址2：">
                  <el-input v-model="serverInfo.asyReceiverUrl2"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  <el-input v-model="serverInfo.confDesc"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12" v-if="channelVisable">
                <el-form-item label="比重：">
                  <el-input-number :min="0" :max="100" v-model="serverInfo.weight" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：">
                  <el-select v-model="serverInfo.status" :value="serverInfo.status" placeholder="请选择状态" style="width: 100%;">
                    <el-option :value="0" label="禁用"/>
                    <el-option :value="1" label="启用"/>
                    <el-option :value="2" label="仅保持原有的通话" v-if="channelVisable"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="channelVisable">
              <el-col :span="12">
                <el-form-item label="延迟时间(ms)：">
                  <el-input-number :min="0" v-model="serverInfo.delayTime" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最大串行数：">
                  <el-input-number :min="0" v-model="serverInfo.maxSerialNum" style="width: 100%;"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="服务类型：">
                  <el-select v-model="serverInfo.type" :value="serverInfo.type" @change="changeType" placeholder="请选择服务类型" style="width: 100%;">
                    <el-option value="msg" label="短信" v-if="channelVisable"/>
                    <el-option value="fmsg" label="闪信" v-if="channelVisable"/>
                    <el-option value="ivr" label="语音" v-if="channelVisable"/>
                    <el-option value="ivoice" label="智能语音" v-if="channelVisable"/>
                    <el-option value="svoice" label="场景语音" v-if="channelVisable"/>
                    <el-option value="other" label="辅助配置" v-if="!channelVisable"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="channelVisable" >
                <el-form-item label="通道类型：" >
                  <el-select v-if="isMsg ==1" v-model="serverInfo.supportChannel" :value="serverInfo.supportChannel" placeholder="请选择通道" style="width: 100%;">
                    <el-option value="N" label="通知短信"/>
                    <el-option value="I" label="交互短信"/>
                    <el-option value="C" label="卡线"/>
                  </el-select>
                  <el-select v-else-if="isMsg ==2" v-model="serverInfo.supportChannel" :value="serverInfo.supportChannel" placeholder="请选择通道" style="width: 100%;">
                    <el-option value="ivrCall" label="ivr"/>
                    <el-option value="washNum" label="洗号"/>
                    <el-option value="hyRobot" label="hy机器人"/>
                  </el-select>
                  <el-select v-else-if="isMsg ==4" v-model="serverInfo.supportChannel" :value="serverInfo.supportChannel" placeholder="请选择通道" style="width: 100%;">
                    <el-option value="voice" label="语音交互通道"/>
                  </el-select>
                  <el-select v-else-if="isMsg ==5" v-model="serverInfo.supportChannel" :value="serverInfo.supportChannel" placeholder="请选择通道" style="width: 100%;">
                    <el-option value="sceneRobot" label="场景语音-机器"/>
                    <el-option value="scenePerson" label="场景语音-声优"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="channelVisable">
              <el-col :span="12">
                <el-form-item label="线路单价(元)：">
                  <el-input-number :min="0" :precision="3" :step="0.01" v-model="serverInfo.unitPrice" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="线路qps：">
                  <el-input-number :min="0" v-model="serverInfo.qps" style="width: 100%;"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="channelVisable">
              <el-col :span="12">
                <el-form-item label="是否重播：" v-if="isMsg === 5">
                  <el-switch
                    v-model="serverInfo.isRetry"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否有资源：">
                  <el-switch
                    v-model="serverInfo.isResource"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="是否开启mock:" v-if="isMsg === 5">
                  <el-switch
                    v-model="serverInfo.isMock"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="fs服务路由配置:" v-if="isMsg === 5">
                  <el-select v-model="serverInfo.fsConf" filterable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in fsConfOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="线路商公司：">
                  <el-select v-model="serverInfo.supplierComId" filterable collapse-tags @change="changeSupplierComId" placeholder="请选择" :filter-method = "searchSupplierInfos" style="width: 100%;">
                    <el-option
                      v-for="item in supplierInfos"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id"
                      :title="item.companyName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="指定FS服务：" >
                  <el-select v-model="serverInfo.selectedFsId" multiple filterable remote placeholder="请选择" :options="fsInfos" :remote-method="searchFsInfos" style="width: 100%;">
                    <el-option
                      v-for="item in fsInfos"
                      :key="item.id"
                      :label="item.fsName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="SBC:" v-if="isMsg === 5">
                  <el-switch
                    v-model="serverInfo.isSbc"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="线路商IP:" v-if="isMsg === 5 && serverInfo.isSbc">
                  <input class="el-input-base" v-model.trim="serverInfo.supplierIp"/>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="线路商端口:" v-if="isMsg === 5 && serverInfo.isSbc">
                  <input class="el-input-base" v-model.trim="serverInfo.supplierPort"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="主叫前缀:" v-if="isMsg === 5 && serverInfo.isSbc">
                  <input class="el-input-base" v-model.trim="serverInfo.originationCallerIdNumber"/>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="被叫前缀:" v-if="isMsg === 5 && serverInfo.isSbc">
                  <input class="el-input-base" v-model.trim="serverInfo.calleePrefix"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="RE-INVITE:" v-if="isMsg === 5 && serverInfo.isSbc">
                  <el-switch
                    v-model="serverInfo.isReInvite"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 频次限制设置 -->
            <!-- 单位时间内总频次设置：开关行 -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="24">
                <el-form-item label="单位时间内总频次设置:">
                  <el-switch
                    v-model="serverInfo.isOpenTotalLimit"
                    active-color="#f6ac19"
                    inactive-color="#282828"
                    @change="handleTotalLimitChange">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 单位时间内总频次设置：配置行（始终显示，按开关禁用） -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="8">
                <el-form-item label="接听次数:">
                  <el-input-number
                    v-model="tempTotalAnsweredCount"
                    :min="0"
                    style="width: 100%;"
                    :disabled="!serverInfo.isOpenTotalLimit"
                    @change="updateTotalFrequencyLimit"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="呼叫次数:">
                  <el-input-number
                    v-model="tempTotalCalloutCount"
                    :min="0"
                    style="width: 100%;"
                    :disabled="!serverInfo.isOpenTotalLimit"
                    @change="updateTotalFrequencyLimit"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位时间限制:">
                  <el-select v-model="tempTotalFrequencyUnitTime" placeholder="请选择" style="width: 100%;" :disabled="!serverInfo.isOpenTotalLimit" @change="updateTotalFrequencyLimit">
                    <el-option
                      v-for="item in timeLimitOption"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 单位时间内呼叫频次设置：开关行 -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="24">
                <el-form-item label="单位时间内呼叫频次设置:">
                  <el-switch
                    v-model="serverInfo.isOpenCalloutLimit"
                    active-color="#f6ac19"
                    inactive-color="#282828"
                    @change="handleCalloutLimitChange">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 单位时间内呼叫频次设置：配置行（始终显示，按开关禁用） -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="8">
                <el-form-item label="呼叫次数:">
                  <el-input-number
                    v-model="tempCalloutFrequencyLimit"
                    :min="1"
                    style="width: 100%;"
                    :disabled="!serverInfo.isOpenCalloutLimit"
                    @change="updateCalloutFrequencyLimit"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位时间限制:">
                  <el-select v-model="tempCalloutFrequencyUnitTime" placeholder="请选择" style="width: 100%;" :disabled="!serverInfo.isOpenCalloutLimit" @change="updateCalloutFrequencyLimit">
                    <el-option
                      v-for="item in timeLimitOption"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 单位时间内接听频次设置：开关行 -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="24">
                <el-form-item label="单位时间内接听频次设置:">
                  <el-switch
                    v-model="serverInfo.isAnsweredCalloutLimit"
                    active-color="#f6ac19"
                    inactive-color="#282828"
                    @change="handleAnsweredLimitChange">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 单位时间内接听频次设置：配置行（始终显示，按开关禁用） -->
            <el-row :gutter="24" v-if="isMsg === 5">
              <el-col :span="8">
                <el-form-item label="接听次数:">
                  <el-input-number
                    v-model="tempAnsweredFrequencyLimit"
                    :min="1"
                    style="width: 100%;"
                    :disabled="!serverInfo.isAnsweredCalloutLimit"
                    @change="updateAnsweredFrequencyLimit"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位时间限制:">
                  <el-select v-model="tempAnsweredFrequencyUnitTime" placeholder="请选择" style="width: 100%;" :disabled="!serverInfo.isAnsweredCalloutLimit" @change="updateAnsweredFrequencyLimit">
                    <el-option
                      v-for="item in timeLimitOption"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveConf" v-if="isAdd">提 交</el-button>
            <el-button type="primary" @click="updateConf" v-if="!isAdd">修 改</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="isAddPort?'新增'+currentSupplierName+'端口':'修改'+currentSupplierName+'端口'" :visible.sync="portOperateVisable" width="40%" center>
          <el-form size="small" label-width="100px" class="margin15-tb">
            <!-- 第一行 -->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="端口">
                  <el-input v-model="portBody.port"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="描述">
                  <el-input v-model="portBody.portDescribe"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-select v-model="portBody.status" :value="portBody.status" placeholder="请选择状态" style="width: 100%;">
                    <el-option :value="0" label="禁用"/>
                    <el-option :value="1" label="启用"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="savePort" v-if="isAddPort">新 增</el-button>
            <el-button type="primary" @click="updatePort" v-if="!isAddPort">修 改</el-button>
          </span>
        </el-dialog>
        <!--撤销cc队列数据请求地址-->
        <el-dialog title="撤销cc队列数据请求地址" :visible.sync="cancelIsVisible" width="40%" center>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="small" label-width="140px">
                <el-form-item label="请求地址">
                  <el-input v-model="serverInfo.confDesc"/>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="timeVisable = false">取 消</el-button>
            <el-button type="primary" @click="updateSessionTime">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      messageMsg: {
        label: '短信',
        value: 'msg',
        totalRecords: null,
        list: []
      },
      messageFmsg: {
        label: '闪信',
        value: 'fmsg',
        totalRecords: null,
        list: []
      },
      messageIvr: {
        label: '语音',
        value: 'ivr',
        totalRecords: null,
        list: []
      },
      messageIvoice: {
        label: '智能语音',
        value: 'ivoice',
        totalRecords: null,
        list: []
      },
      messageSvoice: {
        label: '场景语音',
        value: 'sceneVoice',
        totalRecords: null,
        list: []
      },
      messageOther: {
        label: '其他配置',
        value: 'otherConf',
        totalRecords: null,
        list: []
      },
      timeVisable: false,
      serverVisable: false,
      cancelIsVisible: false,
      isAdd: true,
      channelVisable: true,
      // 1:msg 2：ivr 3：other
      isMsg: 1,
      time: null,
      serverInfo: {
        id: null,
        supplier: null,
        supplierName: null,
        supplierComId: null,
        fsIds: null,
        type: null,
        userName: null,
        password: null,
        requestUrl: null,
        asyReceiverUrl1: null,
        asyReceiverUrl2: null,
        status: null,
        weight: null,
        delayTime: null,
        maxSerialNum: null,
        confDesc: null,
        unitPrice: null,
        isRetry: true,
        isResource: true,
        supportChannel: null,
        isMock: false,
        isSbc: false,
        isReInvite: true,
        supplierIp: null,
        supplierPort: null,
        calleePrefix: null,
        originationCallerIdNumber: null,
        qps: null,
        fsConf: null,
        selectedFsId: [],
        // 频次限制相关字段
        isOpenTotalLimit: false,
        totalFrequencyLimit: '', // 格式：接听次数/呼叫次数/单位时间(分钟)
        isOpenCalloutLimit: false,
        calloutFrequencyUnitTime: '', // 格式：呼叫次数/单位时间(分钟)
        isAnsweredCalloutLimit: false,
        answeredFrequencyUnitTime: '' // 格式：接听次数/单位时间(分钟)
      },
      portVisable: false,
      portRes: [],
      modifyPort: {
        supplierId: null,
        portIds: []
      },
      // 端口列表查询
      portSearchReq: {
        supplierId: null,
        page: 1,
        limit: 10,
        order: 'port',
        sort: 'asc'
      },
      portPageRes: { 'totalRecords': 0, list: [] },
      portBody: {
        id: null,
        supplierId: null,
        port: null,
        status: null,
        portDescribe: null
      },
      portOperateVisable: false,
      isAddPort: false,
      activeName: 'msg',
      portTableVisable: false,
      currentSupplierName: null,
      searchReq: {
        type: null,
        supplierName: null,
        confDesc: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      fsConfOption: [
        {
          value: 1,
          label: '指定服务'
        },
        {
          value: 2,
          label: '增加服务'
        },
        {
          value: 3,
          label: '去除服务'
        }
      ],
      supplierInfos: [],
      fsInfos: [],
      // 临时变量用于频次限制设置界面
      tempTotalAnsweredCount: 0,
      tempTotalCalloutCount: 0,
      tempTotalFrequencyUnitTime: 30,
      tempCalloutFrequencyLimit: 0,
      tempCalloutFrequencyUnitTime: 30,
      tempAnsweredFrequencyLimit: 0,
      tempAnsweredFrequencyUnitTime: 30,
      // 时间限制选项字典
      timeLimitOption: []
    };
  },
  methods: {
    handleClick() {
      this.searchReq.supplierName = null;
      this.searchReq.confDesc = null;
      this.serverList();
    },
    currentChangeConf(page) {
      this.searchReq.page = page;
      this.serverList();
    },
    // 显示条数
    sizeChangeConf(num) {
      this.searchReq.limit = num;
      this.serverList();
    },
    // 服务商列表
    serverList() {
      this.searchReq.type = this.activeName;
      this.$ajax({
        method: 'POST',
        url: '/externalServicesConf/list',
        data: this.searchReq
      }).then((res) => {
        if (this.activeName === 'msg') {
          this.messageMsg.list = res.data.list;
          this.messageMsg.totalRecords = res.data.totalRecords;
        } else if (this.activeName === 'fmsg') {
          this.messageFmsg.list = res.data.list;
          this.messageFmsg.totalRecords = res.data.totalRecords;
        } else if (this.activeName === 'ivr') {
          this.messageIvr.list = res.data.list;
          this.messageIvr.totalRecords = res.data.totalRecords;
        } else if (this.activeName === 'other') {
          this.messageOther.list = res.data.list;
          this.messageOther.totalRecords = res.data.totalRecords;
        } else if (this.activeName === 'ivoice') {
          this.messageIvoice.list = res.data.list;
          this.messageIvoice.totalRecords = res.data.totalRecords;
        } else if (this.activeName === 'svoice') {
          this.messageSvoice.list = res.data.list;
          this.messageSvoice.totalRecords = res.data.totalRecords;
        }
      });
    },
    // 获取会话时长
    sessionTime() {
      this.$ajax({
        method: 'GET',
        url: '/externalServicesConf/sessionTime'
      }).then((res) => {
        this.time = res.data;
      });
    },
    // 更新会话时长
    updateSessionTime() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: `/externalServicesConf/updateSessionTime/${this.time}`
      }).then(() => {
        this.timeVisable = false;
      });
    },
    // 添加服务显示
    addConfShow() {
      // 配置信息
      this.serverInfo.id = null;
      this.serverInfo.supplier = null;
      this.serverInfo.supplierName = null;
      this.serverInfo.supplierComId = null;
      this.serverInfo.fsIds = null;
      this.serverInfo.type = null;
      this.serverInfo.userName = null;
      this.serverInfo.password = null;
      this.serverInfo.requestUrl = null;
      this.serverInfo.asyReceiverUrl1 = null;
      this.serverInfo.asyReceiverUrl2 = null;
      this.serverInfo.status = null;
      this.serverInfo.weight = 0;
      this.serverInfo.delayTime = 0;
      this.serverInfo.maxSerialNum = 0;
      this.serverInfo.unitPrice = 0.0;
      this.serverInfo.isRetry = true;
      this.serverInfo.isResource = true;
      this.serverInfo.confDesc = null;
      this.serverInfo.supportChannel = null;
      this.serverInfo.isMock = false;
      this.serverInfo.fsConf = null;
      this.serverInfo.qps = 0;
      this.serverInfo.selectedFsId = [];
      this.serverInfo.isSbc = false;
      this.serverInfo.isReInvite = true;
      this.serverInfo.supplierIp = null;
      this.serverInfo.supplierPort = null;
      this.serverInfo.calleePrefix = null;
      this.serverInfo.originationCallerIdNumber = null;
      this.serverInfo.isOpenTotalLimit = false;
      this.serverInfo.totalFrequencyLimit = '';
      this.serverInfo.isOpenCalloutLimit = false;
      this.serverInfo.calloutFrequencyUnitTime = '';
      this.serverInfo.isAnsweredCalloutLimit = false;
      this.serverInfo.answeredFrequencyUnitTime = '';
      // 初始化临时变量
      this.initTempVariables();
      this.fsInfos = [];
      // 显示控制
      this.serverVisable = true;
      this.isAdd = true;
      this.channelVisable = true;
      this.isMsg = 1;
    },
    cancelIvrConf() {
      this.cancelIsVisible = true;
      // 请求获取配置信息
      this.$confirm('您确认要修改该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: this.serverInfo,
          url: `/externalServicesConf/updateConf/${this.serverInfo.id}`
        }).then(() => {
          this.serverVisable = false;
          this.serverList();
        });
      });
    },
    // 保存服务
    saveConf() {
      // 验证频次限制设置
      if (!this.validateFrequencyLimits()) {
        return;
      }
      if (this.isMsg === 3) {
        this.serverInfo.delayTime = 0;
        this.serverInfo.supportChannel = 'other';
        this.serverInfo.weight = 0;
        this.serverInfo.maxSerialNum = 0;
        this.serverInfo.unitPrice = 0.0;
        this.serverInfo.qps = 0;
        this.serverInfo.isRetry = true;
        this.serverInfo.isResource = true;
      }
      if (this.serverInfo.selectedFsId !== null && this.serverInfo.selectedFsId !== undefined && this.serverInfo.selectedFsId.length > 0) {
        this.serverInfo.fsIds = this.serverInfo.selectedFsId.join(',');
      }
      // 格式化频次限制数据
      this.formatFrequencyLimits();
      // 构建提交数据，移除关闭或空值字段
      const payload = this.buildSubmitPayload();
      this.$ajax({
        prompt: true,
        method: 'POST',
        data: payload,
        url: '/externalServicesConf/saveConf'
      }).then(() => {
        this.serverVisable = false;
        this.serverList();
      });
    },
    // 编辑服务显示
    editConfShow(row) {
      if (row.type === 'other') {
        this.channelVisable = false;
      } else {
        this.channelVisable = true;
      }
      this.serverVisable = true;

      if (row.type === 'ivoice') {
        this.isMsg = 4;
      } else if (row.type === 'msg' || row.type === 'fmsg') {
        this.isMsg = 1;
      } else if (row.type === 'ivr') {
        this.isMsg = 2;
      } else if (row.type === 'svoice') {
        this.isMsg = 5;
      }

      this.isAdd = false;
      this.buildRowReq(row);
      // 修改的要初始化一下账号的下拉选框
      this.searchFsInfos('');
      if (row.fsIds !== null && row.fsIds !== undefined && row.fsIds !== '') {
        this.serverInfo.selectedFsId = row.fsIds.split(',').map(num => parseInt(num, 10));
      } else {
        this.serverInfo.selectedFsId = [];
      }
    },
    // 修改服务
    updateConf() {
      // 验证频次限制设置
      if (!this.validateFrequencyLimits()) {
        return;
      }
      if (this.serverInfo.selectedFsId !== null && this.serverInfo.selectedFsId !== undefined && this.serverInfo.selectedFsId.length > 0) {
        this.serverInfo.fsIds = this.serverInfo.selectedFsId.join(',');
      } else {
        this.serverInfo.fsIds = '';
      }
      // 格式化频次限制数据
      this.formatFrequencyLimits();
      const payload = this.buildSubmitPayload();
      this.$confirm('您确认要修改该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: payload,
          url: `/externalServicesConf/updateConf/${this.serverInfo.id}`
        }).then(() => {
          this.serverVisable = false;
          this.serverList();
        });
      });
    },
    deleteConf(id) {
      this.$confirm('此操作将永久删除该服务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/externalServicesConf/deleteConf/${id}`
        }).then(() => {
          if (id === this.portSearchReq.supplierId) {
            this.portTableVisable = false;
          }
          this.serverList();
        });
      });
    },
    buildRowReq(row) {
      this.serverInfo.id = row.id;
      this.serverInfo.supplier = row.supplier;
      this.serverInfo.supplierName = row.supplierName;
      this.serverInfo.supplierComId = row.supplierComId;
      this.serverInfo.fsIds = row.fsIds;
      this.serverInfo.type = row.type;
      this.serverInfo.userName = row.userName;
      this.serverInfo.password = row.password;
      this.serverInfo.requestUrl = row.requestUrl;
      this.serverInfo.asyReceiverUrl1 = row.asyReceiverUrl1;
      this.serverInfo.asyReceiverUrl2 = row.asyReceiverUrl2;
      this.serverInfo.status = row.status;
      this.serverInfo.weight = row.weight;
      this.serverInfo.delayTime = row.delayTime;
      this.serverInfo.maxSerialNum = row.maxSerialNum;
      this.serverInfo.unitPrice = row.unitPrice;
      this.serverInfo.isRetry = row.isRetry;
      this.serverInfo.isResource = row.isResource;
      this.serverInfo.confDesc = row.confDesc;
      this.serverInfo.supportChannel = row.supportChannel;
      this.serverInfo.isMock = row.isMock;
      this.serverInfo.fsConf = row.fsConf;
      this.serverInfo.qps = row.qps;
      this.serverInfo.isSbc = row.isSbc;
      this.serverInfo.isReInvite = row.isReInvite;
      this.serverInfo.supplierIp = row.supplierIp;
      this.serverInfo.supplierPort = row.supplierPort;
      this.serverInfo.calleePrefix = row.calleePrefix;
      this.serverInfo.originationCallerIdNumber = row.originationCallerIdNumber;
      this.serverInfo.isOpenTotalLimit = row.isOpenTotalLimit || false;
      this.serverInfo.totalFrequencyLimit = row.totalFrequencyLimit || '';
      this.serverInfo.isOpenCalloutLimit = row.isOpenCalloutLimit || false;
      this.serverInfo.calloutFrequencyUnitTime = row.calloutFrequencyUnitTime || '';
      this.serverInfo.isAnsweredCalloutLimit = row.isAnsweredCalloutLimit || false;
      this.serverInfo.answeredFrequencyUnitTime = row.answeredFrequencyUnitTime || '';
      // 解析格式化数据到临时变量用于界面显示
      this.parseFrequencyLimits();
    },
    // 是否为数字
    isNumeric(value) {
      // 使用 isNaN 和 typeof 进行数字判断
      return !isNaN(parseFloat(value)) && isFinite(value) && typeof value !== 'boolean';
    },
    // 设置端口服务下拉框
    allServers() {
      const array = [];
      this.messageMsg.list.forEach((item) => {
        array.push(item);
      });
      this.messageFmsg.list.forEach((item) => {
        array.push(item);
      });
      this.messageIvr.list.forEach((item) => {
        array.push(item);
      });
      return array;
    },
    // 服务商下拉框选择
    ports(supplierId) {
      this.portRes = [];
      this.modifyPort.portIds = [];
      this.$ajax({
        method: 'POST',
        url: `/externalServicesConf/portList/${supplierId}`,
        data: {
          page: 1,
          limit: 10000,
          order: 'port',
          sort: 'asc'
        }
      }).then((res) => {
        res.data.list.forEach((item) => {
          item.port += '';
          if (item.status === 0) {
            this.modifyPort.portIds.push(item.id);
          }
        });
        this.portRes = res.data.list;
      });
    },
    // 批量修改端口
    modifyPortStatus() {
      this.$confirm('您确定要批量修改端口号吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          url: '/externalServicesConf/updatePortStatus',
          data: {
            supplierId: this.modifyPort.supplierId,
            ids: this.modifyPort.portIds
          }
        }).then(() => {
          this.portVisable = false;
        });
      });
    },
    rowClick(row) {
      if (row.type === 'msg' || row.type === 'fmsg') {
        this.isMsg = 1;
      } else if (row.type === 'ivr') {
        this.isMsg = 2;
      } else if (row.type === 'other') {
        this.isMsg = 3;
      }
      this.currentSupplierName = row.supplierName;
      this.portTableVisable = true;
      if (this.portSearchReq.supplierId === row.id) {
        return;
      }
      this.portSearchReq.supplierId = row.id;
      this.portSearchReq.page = 1;
      // 新增、修改端口传入当前supplier id
      this.portBody.supplierId = row.id;
      this.portList();
    },
    portSort(column) {
      console.warn('sort');
      const prop = column.prop;
      const order = column.order;
      this.portSearchReq.order = prop === null ? 'port' : prop;
      if (order === 'descending') {
        this.portSearchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.portSearchReq.sort = 'asc';
      }
      this.portList();
    },
    // 服务商端口列表
    portList() {
      this.$ajax({
        method: 'POST',
        url: `/externalServicesConf/portList/${this.portSearchReq.supplierId}`,
        data: this.portSearchReq
      }).then((res) => {
        this.portPageRes = res.data;
      });
    },
    currentChange(page) {
      this.portSearchReq.page = page;
      this.portList();
    },
    // 显示条数
    sizeChange(num) {
      this.portSearchReq.limit = num;
      this.portList();
    },
    addPortShow() {
      this.isAddPort = true;
      this.portOperateVisable = true;
      // 制空
      this.clearPort();
    },
    savePort() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/externalServicesConf/savePort',
        data: this.portBody
      }).then(() => {
        this.portOperateVisable = false;
        this.portList();
      });
    },
    updatePortShow(row) {
      this.isAddPort = false;
      this.portOperateVisable = true;
      // 制空
      this.clearPort();
      this.copyPort(row);
    },
    updatePort() {
      this.$confirm('您确定要修改该端口吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          url: `/externalServicesConf/updatePort/${this.portBody.id}`,
          data: this.portBody
        }).then(() => {
          this.portOperateVisable = false;
          this.portList();
        });
      });
    },
    clearPort() {
      this.portBody.id = null;
      this.portBody.port = null;
      this.portBody.status = null;
      this.portBody.portDescribe = null;
    },
    copyPort(row) {
      this.portBody.id = row.id;
      this.portBody.port = row.port;
      this.portBody.status = row.status;
      this.portBody.portDescribe = row.portDescribe;
    },
    deletePort(id) {
      this.$confirm('此操作将永久删除该端口, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/externalServicesConf/deletePort/${id}`
        }).then(() => {
          this.portList();
        });
      });
    },
    changeType() {
      if (this.serverInfo.type === 'msg' || this.serverInfo.type === 'fmsg') {
        this.isMsg = 1;
        this.channelVisable = true;
      } else if (this.serverInfo.type === 'ivr') {
        this.isMsg = 2;
        this.channelVisable = true;
      } else if (this.serverInfo.type === 'other') {
        this.isMsg = 3;
        this.channelVisable = false;
      } else if (this.serverInfo.type === 'ivoice') {
        this.isMsg = 4;
        this.channelVisable = true;
      } else if (this.serverInfo.type === 'svoice') {
        this.isMsg = 5;
        this.channelVisable = true;
      }
      this.serverInfo.supportChannel = null;
    },
    changeSupplierComId() {
      this.searchFsInfos('');
      this.serverInfo.selectedFsId = [];
    },
    searchFsInfos(val) {
      const queryUrl = `/callServer/box/searchFsInfos?fsName=${val}&supplierComId=${this.serverInfo.supplierComId}`;
      this.$ajax({
        method: 'GET',
        url: queryUrl
      }).then((res) => {
        this.fsInfos = [];
        this.fsInfos = res.data;
      });
    },
    addOtherConfShow() {
      // 配置信息
      this.serverInfo.id = null;
      this.serverInfo.supplier = null;
      this.serverInfo.supplierName = null;
      this.serverInfo.supplierComId = 0;
      this.serverInfo.type = null;
      this.serverInfo.userName = null;
      this.serverInfo.password = null;
      this.serverInfo.requestUrl = null;
      this.serverInfo.asyReceiverUrl1 = null;
      this.serverInfo.asyReceiverUrl2 = null;
      this.serverInfo.status = null;
      this.serverInfo.weight = 0;
      this.serverInfo.delayTime = 0;
      this.serverInfo.maxSerialNum = 0;
      this.serverInfo.confDesc = null;
      this.serverInfo.unitPrice = 0.0;
      this.serverInfo.isRetry = true;
      this.serverInfo.isResource = true;
      this.serverInfo.qps = 0;
      this.serverInfo.supportChannel = null;
      // 频次限制字段初始化
      this.serverInfo.isOpenTotalLimit = false;
      this.serverInfo.totalFrequencyLimit = '';
      this.serverInfo.isOpenCalloutLimit = false;
      this.serverInfo.calloutFrequencyUnitTime = '';
      this.serverInfo.isAnsweredCalloutLimit = false;
      this.serverInfo.answeredFrequencyUnitTime = '';
      // 初始化临时变量
      this.initTempVariables();
      // 显示控制
      this.isMsg = 3;
      this.channelVisable = false;
      this.serverVisable = true;
      this.isAdd = true;
    },
    // 线路商下拉框
    getSupplierInfos() {
      const val = '';
      this.$ajax({
        url: '/callServer/getSupplierInfos',
        data: { 'supplierName': val }
      }).then((res) => {
        this.supplierInfos = res.data;
      });
    },
    // 线路商搜索
    searchSupplierInfos(val) {
      this.$ajax({
        url: '/callServer/getSupplierInfos',
        data: { 'supplierName': val }
      }).then((res) => {
        this.supplierInfos = res.data;
      });
    },
    handleTotalLimitChange() {
      if (!this.serverInfo.isOpenTotalLimit) {
        // 不重置临时值，保留用户原先配置，仅清空提交字段
        this.serverInfo.totalFrequencyLimit = '';
      } else {
        // 开启时根据当前临时值同步一次提交字段
        this.formatFrequencyLimits();
      }
    },
    initTempVariables() {
      // 添加服务时，时间选择默认为空，显示"请选择"
      this.tempTotalAnsweredCount = 0;
      this.tempTotalCalloutCount = 0;
      this.tempTotalFrequencyUnitTime = null;
      this.tempCalloutFrequencyLimit = 0;
      this.tempCalloutFrequencyUnitTime = null;
      this.tempAnsweredFrequencyLimit = 0;
      this.tempAnsweredFrequencyUnitTime = null;
    },
    getTimeLimitOption() {
      this.$ajax({
        method: 'GET',
        url: '/dict/list/time_limit_of_callFrequency'
      }).then((res) => {
        this.timeLimitOption = res.data;
        // 只有在添加模式下才重新初始化临时变量，编辑模式下保持原有数据
        if (this.serverVisable && this.isAdd) {
          this.initTempVariables();
        }
      });
    },
    handleCalloutLimitChange() {
      if (!this.serverInfo.isOpenCalloutLimit) {
        // 不重置临时值，保留用户原先配置，仅清空提交字段
        this.serverInfo.calloutFrequencyUnitTime = '';
      } else {
        this.formatFrequencyLimits();
      }
    },
    handleAnsweredLimitChange() {
      if (!this.serverInfo.isAnsweredCalloutLimit) {
        // 不重置临时值，保留用户原先配置，仅清空提交字段
        this.serverInfo.answeredFrequencyUnitTime = '';
      } else {
        this.formatFrequencyLimits();
      }
    },
    // 验证频次限制设置
    validateFrequencyLimits() {
      let isValid = true;
      // 验证总频次设置
      if (this.serverInfo.isOpenTotalLimit) {
        if (this.tempTotalAnsweredCount <= 0 || this.tempTotalCalloutCount <= 0) {
          this.$message.error('单位时间内总频次设置中,接听次数和呼叫次数必须大于0');
          isValid = false;
        }
        // 验证总频次时间选择
        if (!this.tempTotalFrequencyUnitTime) {
          this.$message.error('单位时间内总频次设置中,时间选择不能为空');
          isValid = false;
        }
      }
      // 验证呼叫频次设置
      if (this.serverInfo.isOpenCalloutLimit) {
        if (this.tempCalloutFrequencyLimit <= 0) {
          this.$message.error('单位时间内呼叫频次设置中,呼叫次数必须大于0');
          isValid = false;
        }
        // 验证呼叫频次时间选择
        if (!this.tempCalloutFrequencyUnitTime) {
          this.$message.error('单位时间内呼叫频次设置中,时间选择不能为空');
          isValid = false;
        }
      }
      // 验证接听频次设置
      if (this.serverInfo.isAnsweredCalloutLimit) {
        if (this.tempAnsweredFrequencyLimit <= 0) {
          this.$message.error('单位时间内接听频次设置中,接听次数必须大于0');
          isValid = false;
        }
        // 验证接听频次时间选择
        if (!this.tempAnsweredFrequencyUnitTime) {
          this.$message.error('单位时间内接听频次设置中,时间选择不能为空');
          isValid = false;
        }
      }
      // 验证总频次限制逻辑：总频次设置的数量要大于等于其他两个设置的数量
      if (this.serverInfo.isOpenTotalLimit) {
        // 总频次设置中，呼叫次数必须大于等于接听次数
        if (this.tempTotalCalloutCount < this.tempTotalAnsweredCount) {
          this.$message.error('总频次设置中，呼叫次数必须大于等于接听次数');
          isValid = false;
        }
        if (this.serverInfo.isOpenCalloutLimit && this.tempTotalCalloutCount < this.tempCalloutFrequencyLimit) {
          this.$message.error('总频次设置中的呼叫次数必须大于等于呼叫频次设置中的呼叫次数');
          isValid = false;
        }
        if (this.serverInfo.isAnsweredCalloutLimit && this.tempTotalAnsweredCount < this.tempAnsweredFrequencyLimit) {
          this.$message.error('总频次设置中的接听次数必须大于等于接听频次设置中的接听次数');
          isValid = false;
        }
      }
      // 验证时间间隔关系
      if (this.serverInfo.isOpenTotalLimit) {
        if (this.serverInfo.isOpenCalloutLimit) {
          // C(d) ≤ S(d) 呼叫时间间隔不能大于总频次中的时间间隔
          if (this.parseTimeWithUnit(this.tempCalloutFrequencyUnitTime) > this.parseTimeWithUnit(this.tempTotalFrequencyUnitTime)) {
            this.$message.error('呼叫频次设置中的时间间隔不能大于总频次设置中的时间间隔');
            isValid = false;
          }
        }
        if (this.serverInfo.isAnsweredCalloutLimit) {
          // A(d) ≤ S(d) 接听时间间隔不能大于总频次中的时间间隔
          if (this.parseTimeWithUnit(this.tempAnsweredFrequencyUnitTime) > this.parseTimeWithUnit(this.tempTotalFrequencyUnitTime)) {
            this.$message.error('接听频次设置中的时间间隔不能大于总频次设置中的时间间隔');
            isValid = false;
          }
        }
      }
      // 验证接听频次与呼叫频次的关系
      if (this.serverInfo.isOpenCalloutLimit && this.serverInfo.isAnsweredCalloutLimit) {
        // A(a) ≤ C(c) 接听次数不能超过呼叫次数
        if (this.tempAnsweredFrequencyLimit > this.tempCalloutFrequencyLimit) {
          this.$message.error('接听频次设置中的接听次数不能超过呼叫频次设置中的呼叫次数');
          isValid = false;
        }
        // A(d) ≤ C(d) 接听时间间隔不能大于呼叫时间间隔
        if (this.parseTimeWithUnit(this.tempAnsweredFrequencyUnitTime) > this.parseTimeWithUnit(this.tempCalloutFrequencyUnitTime)) {
          this.$message.error('接听频次设置中的时间间隔不能大于呼叫频次设置中的时间间隔');
          isValid = false;
        }
      }
      return isValid;
    },
    // 格式化频次限制数据
    formatFrequencyLimits() {
      // 格式化总频次限制数据，按照 接听次数/呼叫次数/单位时间(分钟) 的格式
      if (this.serverInfo.isOpenTotalLimit) {
        this.serverInfo.totalFrequencyLimit = `${this.tempTotalAnsweredCount}/${this.tempTotalCalloutCount}/${this.tempTotalFrequencyUnitTime}`;
      } else {
        this.serverInfo.totalFrequencyLimit = '';
      }
      // 格式化呼叫频次限制数据
      if (this.serverInfo.isOpenCalloutLimit) {
        this.serverInfo.calloutFrequencyUnitTime = `${this.tempCalloutFrequencyLimit}/${this.tempCalloutFrequencyUnitTime}`;
      } else {
        this.serverInfo.calloutFrequencyUnitTime = '';
      }
      // 格式化接听频次限制数据
      if (this.serverInfo.isAnsweredCalloutLimit) {
        this.serverInfo.answeredFrequencyUnitTime = `${this.tempAnsweredFrequencyLimit}/${this.tempAnsweredFrequencyUnitTime}`;
      } else {
        this.serverInfo.answeredFrequencyUnitTime = '';
      }
    },
    updateTotalFrequencyLimit() {
      this.formatFrequencyLimits();
    },
    updateCalloutFrequencyLimit() {
      this.formatFrequencyLimits();
    },
    updateAnsweredFrequencyLimit() {
      this.formatFrequencyLimits();
    },
    // 解析格式化数据到临时变量用于界面显示
    parseFrequencyLimits() {
      // 解析总频次限制数据
      if (this.serverInfo.totalFrequencyLimit && this.serverInfo.totalFrequencyLimit.includes('/')) {
        const parts = this.serverInfo.totalFrequencyLimit.split('/');
        if (parts.length === 3) {
          this.tempTotalAnsweredCount = parseInt(parts[0], 10) || 0;
          this.tempTotalCalloutCount = parseInt(parts[1], 10) || 0;
          // 保存原始时间字符串用于界面显示
          this.tempTotalFrequencyUnitTime = parts[2];
        }
      } else {
        // 如果没有格式化数据，重置临时变量
        this.tempTotalAnsweredCount = 0;
        this.tempTotalCalloutCount = 0;
        this.tempTotalFrequencyUnitTime = null;
      }
      // 解析呼叫频次限制数据
      if (this.serverInfo.calloutFrequencyUnitTime && this.serverInfo.calloutFrequencyUnitTime.includes('/')) {
        const parts = this.serverInfo.calloutFrequencyUnitTime.split('/');
        if (parts.length === 2) {
          this.tempCalloutFrequencyLimit = parseInt(parts[0], 10) || 0;
          // 保存原始时间字符串用于界面显示
          this.tempCalloutFrequencyUnitTime = parts[1];
        }
      } else {
        // 如果没有格式化数据，重置临时变量
        this.tempCalloutFrequencyLimit = 0;
        this.tempCalloutFrequencyUnitTime = null;
      }
      // 解析接听频次限制数据
      if (this.serverInfo.answeredFrequencyUnitTime && this.serverInfo.answeredFrequencyUnitTime.includes('/')) {
        const parts = this.serverInfo.answeredFrequencyUnitTime.split('/');
        if (parts.length === 2) {
          this.tempAnsweredFrequencyLimit = parseInt(parts[0], 10) || 0;
          // 保存原始时间字符串用于界面显示
          this.tempAnsweredFrequencyUnitTime = parts[1];
        }
      } else {
        // 如果没有格式化数据，重置临时变量
        this.tempAnsweredFrequencyLimit = 0;
        this.tempAnsweredFrequencyUnitTime = null;
      }
    },
    // 解析带时间单位的时间字符串，返回分钟数
    parseTimeWithUnit(timeStr) {
      if (!timeStr) return 0;

      const str = timeStr.toString().trim();
      const num = parseInt(str.match(/\d+/), 10) || 0;

      if (str.includes('H') || str.includes('小时')) {
        return num * 60; // 小时转分钟
      }
      if (str.includes('D') || str.includes('天')) {
        return num * 24 * 60; // 天转分钟
      }
      if (str.includes('min') || str.includes('分钟')) {
        return num; // 分钟
      }
      // 如果没有单位，默认按分钟处理
      return num;
    },
    // 按开关状态剔除字段
    buildSubmitPayload() {
      const data = JSON.parse(JSON.stringify(this.serverInfo));
      if (!data.isOpenTotalLimit || !data.totalFrequencyLimit) {
        delete data.totalFrequencyLimit;
      }
      if (!data.isOpenCalloutLimit || !data.calloutFrequencyUnitTime) {
        delete data.calloutFrequencyUnitTime;
      }
      if (!data.isAnsweredCalloutLimit || !data.answeredFrequencyUnitTime) {
        delete data.answeredFrequencyUnitTime;
      }
      return data;
    }
  },
  mounted() {
    // 服务列表
    this.serverList();
    // 线路商下拉框
    this.getSupplierInfos();
    // 获取时间限制选项
    this.getTimeLimitOption();
  }
};
</script>
<style>
  div.el-transfer .el-transfer-panel {width: 40%;}
  .el-input-base {
    /* 宽度 */
    width: 100%;
    /* 标准高度 */
    height: 32px;
    /* 适当圆角 */
    border-radius: 4px;
    /* 浅灰色边框 */
    border: 1px solid #d9d9d9;
    /* 内边距 */
    padding: 0 12px;
    /* 字体样式 */
    font-size: 14px;
    color: #969696;
    /* 过渡效果 */
    transition: all 0.2s ease;
    box-sizing: border-box;
  }
  .el-input-base::placeholder {
    color: #bfbfbf;
  }
  .el-input-base:hover {
    border-color: #b3b3b3;
  }
  .el-input-base:focus {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.2);
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/call/default/index.vue